export * as deployments from '@wix/auto_sdk_editor-deployments_deployments/meta';
